<script>
    import { getContext, onMount } from "svelte";
    import { version, refreshVersion } from "../stores.js";
    import { api_info } from "../api/client.js";

    const context = getContext(api_info);

    let version_value;
    version.subscribe((value) => {
        version_value = value;
    });
    onMount(() => {
        refreshVersion(context);
    });
</script>

{#if version_value}
    <div
        class="footer navbar-fixed-bottom bg-info"
        id="version"
        style="padding: 15px;"
    >
        เวอร์ชั่น {version_value}
    </div>
{/if}
